'use strict';

var React = require('react');
var component$2 = require('../Accordion/component.js');
var component$1 = require('../Divider/component.js');
var component = require('../Text/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const HeaderNavItemTablet = React.forwardRef(({ tab, isActive, subItems, ...props }, ref) => {
    const summary = (React__default.default.createElement(component.Text, { variant: "body", as: "div" }, tab));
    const divider = React__default.default.createElement(component$1.Divider, null);
    return subItems ? (React__default.default.createElement(component$2.Accordion, { ...props, ref: ref, px: null, divider: divider, summary: React__default.default.createElement(styles.Styled.Tab, { isActive: isActive }, summary), icon: React__default.default.createElement(styles.Styled.DropdownIcon, { name: "down-filled", "aria-label": "open sub items" }) }, subItems)) : (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(styles.Styled.Tab, { ...props, ref: ref, isActive: isActive },
            React__default.default.createElement(styles.Styled.TabletSummary, null, summary)),
        divider));
});

exports.HeaderNavItemTablet = HeaderNavItemTablet;
//# sourceMappingURL=Tablet.js.map
